export default {
    loadingPercent: 0,
    sizeDownloaded: 0,
    activeDownloads: [],
    completeDownloads: [],
};